<nav class="fixed top-0 left-0 z-50 w-screen">
  <div
    [ngClass]="{
      'bg-red-300 dark:bg-red-700': envMode === 'development',
      'bg-orange-400 dark:bg-orange-500': envMode === 'test',
      'bg-white dark:bg-slate-950': envMode === 'production',
    }"
    class="relative flex items-center justify-between w-full h-12 px-4 transition-colors duration-200 shadow-lg shadow-gray-200 dark:shadow-slate-900"
    role="navigation"
    aria-label="Navegação principal"
  >
    <!-- Logo e Menu Mobile -->
    <div class="flex items-center gap-3">
      <div
        [matTooltip]="nameBranch"
        class="flex items-center justify-center overflow-hidden transition-transform rounded-md hover:scale-105"
        [style.background]="'color_cod' | branch"
        aria-label="Logo da empresa"
      >
        <img
          src="assets/images/logo/logo_color.svg"
          alt="Logo"
          class="h-10 w-auto p-2 min-w-[50px]"
          loading="eager"
        />
      </div>

      <!-- Menu hamburguer (mobile) -->
      <MenuLink icon="menu" (click)="openSidebar()" matTooltip="Abrir menu" />
    </div>

    <!-- Links de Navegação (Desktop) -->
    <div
      class="flex items-center justify-center flex-1 max-w-4xl gap-1 mx-auto"
    >
      <MenuLink
        mattolltip="Quantidade de reservas hoje na unidade"
        *HasRole="['RESERVA']"
        icon="calendar"
        [label]="'Reservas  (' + (menuCountData?.schedule_count ?? 0) + ')'"
        link="/reservas"
        ariaLabel="Ir para Reservas"
      />

      <!-- Dropdown Entradas -->
      <div *HasRole="['ENTRADA', 'CHECKLIST']" class="relative">
        <button
          type="button"
          (click)="toggleDropdown('entradas')"
          class="hover:bg-gray-800 hover:text-white rounded-md p-1 px-3 mx-1 transition-all flex items-center justify-center"
          [class.bg-blue-900]="dropdowns.entradas"
          [class.text-white]="dropdowns.entradas"
          aria-haspopup="true"
          [attr.aria-expanded]="dropdowns.entradas"
        >
          <div class="flex items-center justify-center">
            <Icon class="text-3xl lg:text-xl lg:me-2" src="barrier" />
            <div class="hidden lg:block truncate text-sm">Entradas</div>
            <Icon
              class="ms-1 text-xs"
              [src]="dropdowns.entradas ? 'arrow-up' : 'arrow-down'"
            />
          </div>
        </button>

        <!-- Dropdown Menu -->
        <div
          *ngIf="dropdowns.entradas"
          class="absolute left-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50"
          (click)="closeAllDropdowns()"
        >
          <div class="py-2">
            <a
              *HasRole="['ENTRADA']"
              routerLink="/entrada"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon src="barrier" class="me-3 text-xl" />
              <span>Entrada</span>
            </a>
            <a
              *HasRole="['CHECKLIST']"
              routerLink="/checklists"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon src="checklist" class="me-3 text-xl" />
              <span>Checklists</span>
            </a>
            <a
              routerLink="/camera/alertas"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon
                src="fa-solid fa-camera"
                [useFontAwsome]="true"
                class="me-5 text-xl"
              />
              <span>Alertas das câmeras</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Dropdown Pátio -->
      <div *HasRole="['PENDENTE', 'PATIO', 'CONFERENCIA']" class="relative">
        <button
          type="button"
          (click)="toggleDropdown('patio')"
          class="hover:bg-gray-800 hover:text-white rounded-md p-1 px-3 mx-1 transition-all flex items-center justify-center"
          [class.bg-blue-900]="dropdowns.patio"
          [class.text-white]="dropdowns.patio"
          aria-haspopup="true"
          [attr.aria-expanded]="dropdowns.patio"
        >
          <div class="flex items-center justify-center">
            <Icon class="text-3xl lg:text-xl lg:me-2" src="patio" />
            <div class="hidden lg:block truncate text-sm">Pátio</div>
            <Icon
              class="ms-1 text-xs"
              [src]="dropdowns.patio ? 'arrow-up' : 'arrow-down'"
            />
          </div>
        </button>

        <!-- Dropdown Menu -->
        <div
          *ngIf="dropdowns.patio"
          class="absolute left-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50"
          (click)="closeAllDropdowns()"
        >
          <div class="py-2">
            <a
              *HasRole="['PENDENTE']"
              routerLink="/v2/patio/pendentes"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon src="car-pending" class="me-3 text-xl" />
              <span>Pendentes</span>
            </a>
            <a
              *HasRole="['PATIO']"
              routerLink="/v2/patio"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon src="patio" class="me-3 text-xl" />
              <span>Pátio</span>
            </a>
            <a
              *HasRole="['CONFERENCIA']"
              routerLink="/conferencias"
              routerLinkActive="bg-blue-100 dark:bg-blue-900"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Icon src="conference" class="me-3 text-xl" />
              <span>Conferências</span>
            </a>
          </div>
        </div>
      </div>

      <MenuLink
        *HasRole="['CAIXA']"
        icon="wallet"
        label="Caixa"
        link="/caixa"
        ariaLabel="Ir para Caixa"
      />

      <MenuLink
        *HasRole="['PAINEL_CONTROLE']"
        icon="reports"
        label="Painel"
        link="/painel-de-controle"
        ariaLabel="Ir para Painel de Controle"
        class="hidden md:block"
      />
      <MenuLink
        *HasRole="['DASHBOARD']"
        icon="fa-solid fa-chart-line"
        [useFontAwsome]="true"
        label="Dashboard"
        link="/dashboard/visao-geral-empresa"
        ariaLabel="Ir para Painel de Controle"
        class="hidden md:block"
      />
    </div>

    <!-- Área de informações e ações (direita) -->
    <div class="flex items-center gap-3">
      <!-- Badge de ambiente (quando não é produção) -->
      @if (envMode !== "production") {
        <span
          class="hidden md:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200 animate-pulse"
          role="status"
          aria-label="Ambiente de desenvolvimento"
        >
          {{ envMode | uppercase }}
        </span>
      }

      <span class="badge bg-slate-400 text-slate-800"
        >CX-{{ cx | number: "3.0" }}</span
      >

      <!-- Versão -->
      <span
        class="items-center hidden text-xs text-gray-500 lg:flex dark:text-gray-400"
        aria-label="Versão do sistema"
      >
        v{{ versionService.get }}
      </span>

      <!-- Slot para conteúdo adicional (ex: notificações, perfil) -->
      <div class="flex items-center">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</nav>

<!-- Spacer para empurrar conteúdo para baixo -->
<div class="h-14 md:h-14" aria-hidden="true"></div>
